<template>
    <div>
        <div class="bg-white cursor-pointer hover:shadow-md transition-shadow flex relative">
            <span v-if="item.fylkeNavn" class="bg-green-200 py-2 px-4 float-right text-xs uppercase">
                {{ item.fylkeNavn }}
            </span>
        </div>
        <div class="bg-white cursor-pointer hover:shadow-md transition-shadow flex pt-2 p-4 relative">
            <div class="w-16 flex-none">
                <img :src="item.fylkesvaapenUrl"
                        :alt="'Fylkesvåpen for ' + item.fylkeNavn"
                        class="w-12 m-2 ml-0" />
            </div>

            <div class="flex-grow">
                <h3 v-if="item.name" class="font-bold text-lg">
                    {{ item.name }}
                </h3>

                <p v-if="item.kommune" class="text-gray-500 mb-2">
                    {{ item.kommune }}
                </p>

                <p v-if="item.ekstrakt" v-html="item.ekstrakt" class="article hidden md:block text-sm"></p>
            </div>
            <a :href="item.url"
                :title="item.name"
                class="absolute top-0 left-0 w-full h-full">
                <span class="sr-only">
                    {{ item.name }}
                </span>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: ['item']
};
</script>
